export const category = [
  {
    img: "https://i.pinimg.com/736x/fd/4b/1e/fd4b1e9fbbee80cb8528fea54cddcb50.jpg",
    name: "Burgers",
    off: "20-40% OFF",
  },
  {
    img: "https://img.freepik.com/premium-photo/huge-selection-peeroni-pizza-with-tomato-sauce-sausage-dark-table_124507-61025.jpg",
    name: "Pizzas",
    off: "10-20% OFF",
  },
  {
    img: "./assets/images/biriani.jpg",
    name: "Biriyanis",
    off: "20-40% OFF",
  },
  {
    img: "./assets/images/desserts.jpg",
    name: "Desserts",
    off: "30-40% OFF",
  },
  {
    img: "https://media.istockphoto.com/id/1366811190/photo/different-type-of-coktails-on-wooden-table.jpg?s=612x612&w=0&k=20&c=BS4lAi77xCxn7LkMleAkw56H-IBaSzE1P2tQuUJcQlQ=",
    name: "Beverages",
    off: "10-40% OFF",
  },
];

export const filter = [
  {
    name: "Food Categories",
    value: "category",
    items: [
      "Noodles",
      "Burger",
      "Pizza",
      "Pasta",
      "Sushi",
      "Tacos",
      "Salads",
      "Sandwiches",
      "Dessert",
      "Beverages",
    ],
  },
  {
    name: "Filter by Price",
    value: "price",
    items: [],
  },
];
